import { ICountry } from 'src/app/entities/countries/state/country.model';
import { CountryCode } from '@app-shared/enums/country-codes.enum';
import { MapWithDefault } from '@app-shared/functions/helpers.functions';

import { SortByFilter } from '../entities/products/enums/sort-by-filters.enum';

/** Delay for the page change event on the paginator. Defaults to 250 */
export const DEFAULT_PAGE_CHANGE_DELAY = 250;

export const DEFAULT_SORT_BY = SortByFilter.IS_SANDOZ;

const DEFAULT_VIEW_ALL_SORT_BY_FILTERS = [
  SortByFilter.NAME,
  SortByFilter.BIGGEST_VOLUME,
  SortByFilter.SHORTAGE_STATUS,
  SortByFilter.PRICE,
  SortByFilter.IS_SANDOZ,
];
const DEFAULT_VIEW_SHORTAGE_SORT_BY_FILTERS = [
  SortByFilter.NAME,
  SortByFilter.BIGGEST_VOLUME,
  SortByFilter.SHORTAGE_DATE,
  SortByFilter.PRICE,
  SortByFilter.SANDOZ_ALTERNATIVE_AVAILABLE,
  SortByFilter.IS_SANDOZ,
];
const DEFAULT_VIEW_EXPECTED_SHORTAGE_SORT_BY_FILTERS = [
  SortByFilter.NAME,
  SortByFilter.BIGGEST_VOLUME,
  SortByFilter.SHORTAGE_DATE,
  SortByFilter.PRICE,
  SortByFilter.SANDOZ_ALTERNATIVE_AVAILABLE,
  SortByFilter.IS_SANDOZ,
];
const DEFAULT_VIEW_BACK_IN_STOCK_SORT_BY_FILTERS = [
  SortByFilter.NAME,
  SortByFilter.BIGGEST_VOLUME,
  SortByFilter.BACK_IN_STOCK_DATE,
  SortByFilter.PRICE,
  SortByFilter.IS_SANDOZ,
];

export const DEFAULT_VIEW_SORTALYS_SORT_BY_FILTERS = [
  SortByFilter.NAME,
  SortByFilter.BIGGEST_VOLUME,
  SortByFilter.SHORTAGE_STATUS,
  SortByFilter.PRICE,
  SortByFilter.IS_SANDOZ,
  SortByFilter.NEW_LISTINGS,
];

export const defaultViewAllSortByFiltersMap = new MapWithDefault<
  ICountry['country_code'],
  SortByFilter[]
>(DEFAULT_VIEW_ALL_SORT_BY_FILTERS);
defaultViewAllSortByFiltersMap.set(CountryCode.ITALIA, [
  SortByFilter.NAME,
  SortByFilter.BIGGEST_VOLUME,
  SortByFilter.SHORTAGE_STATUS,
  SortByFilter.IS_SANDOZ,
]);
defaultViewAllSortByFiltersMap.set(CountryCode.CZECH, [
  SortByFilter.NAME,
  SortByFilter.SHORTAGE_STATUS,
  SortByFilter.IS_SANDOZ,
]);
defaultViewAllSortByFiltersMap.set(CountryCode.BELGIUM, [
  SortByFilter.NAME,
  SortByFilter.SHORTAGE_STATUS,
  SortByFilter.IS_SANDOZ,
]);

export const defaultViewShortageSortByFiltersMap = new MapWithDefault<
  ICountry['country_code'],
  SortByFilter[]
>(DEFAULT_VIEW_SHORTAGE_SORT_BY_FILTERS);
defaultViewShortageSortByFiltersMap.set(CountryCode.ITALIA, [
  SortByFilter.NAME,
  SortByFilter.BIGGEST_VOLUME,
  SortByFilter.SHORTAGE_DATE,
  SortByFilter.SANDOZ_ALTERNATIVE_AVAILABLE,
  SortByFilter.IS_SANDOZ,
]);
defaultViewShortageSortByFiltersMap.set(CountryCode.CZECH, [
  SortByFilter.NAME,
  SortByFilter.SHORTAGE_DATE,
  SortByFilter.SANDOZ_ALTERNATIVE_AVAILABLE,
  SortByFilter.IS_SANDOZ,
]);
defaultViewShortageSortByFiltersMap.set(CountryCode.BELGIUM, [
  SortByFilter.NAME,
  SortByFilter.SHORTAGE_DATE,
  SortByFilter.PRICE,
  SortByFilter.SANDOZ_ALTERNATIVE_AVAILABLE,
  SortByFilter.IS_SANDOZ,
]);

export const defaultViewExpectedShortageSortByFiltersMap = new MapWithDefault<
  ICountry['country_code'],
  SortByFilter[]
>(DEFAULT_VIEW_EXPECTED_SHORTAGE_SORT_BY_FILTERS);

export const defaultViewBackInStockSortByFiltersMap = new MapWithDefault<
  ICountry['country_code'],
  SortByFilter[]
>(DEFAULT_VIEW_BACK_IN_STOCK_SORT_BY_FILTERS);
defaultViewBackInStockSortByFiltersMap.set(CountryCode.ITALIA, [
  SortByFilter.NAME,
  SortByFilter.BIGGEST_VOLUME,
  SortByFilter.BACK_IN_STOCK_DATE,
  SortByFilter.IS_SANDOZ,
]);
defaultViewBackInStockSortByFiltersMap.set(CountryCode.CZECH, [
  SortByFilter.NAME,
  SortByFilter.BACK_IN_STOCK_DATE,
  SortByFilter.IS_SANDOZ,
]);
defaultViewBackInStockSortByFiltersMap.set(CountryCode.BELGIUM, [
  SortByFilter.NAME,
  SortByFilter.BACK_IN_STOCK_DATE,
  SortByFilter.PRICE,
  SortByFilter.IS_SANDOZ,
]);

export const defaultViewSortalysSortByFiltersMap = new MapWithDefault<
  ICountry['country_code'],
  SortByFilter[]
>(DEFAULT_VIEW_SORTALYS_SORT_BY_FILTERS);
defaultViewAllSortByFiltersMap.set(CountryCode.ITALIA, [
  SortByFilter.NAME,
  SortByFilter.BIGGEST_VOLUME,
  SortByFilter.SHORTAGE_STATUS,
  SortByFilter.IS_SANDOZ,
]);
defaultViewAllSortByFiltersMap.set(CountryCode.CZECH, [
  SortByFilter.NAME,
  SortByFilter.SHORTAGE_STATUS,
  SortByFilter.IS_SANDOZ,
]);
defaultViewAllSortByFiltersMap.set(CountryCode.BELGIUM, [
  SortByFilter.NAME,
  SortByFilter.SHORTAGE_STATUS,
  SortByFilter.IS_SANDOZ,
]);
